import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { downloadDecisionNodeMedia } from '../services/api';

// Los archivos de decision_trees requieren JWT, así que no se pueden
// referenciar con un <img src> directo — se trae el blob autenticado
// y se resuelve a una object URL local.
const DecisionMedia = ({ media, sx = {}, videoProps = {} }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    setError(false);
    setUrl(null);

    downloadDecisionNodeMedia(media.id)
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => { if (!cancelled) setError(true); });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [media.id]);

  if (error) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'action.hover', color: 'text.disabled', ...sx }}>
        <BrokenImageIcon />
      </Box>
    );
  }

  if (!url) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'action.hover', ...sx }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (media.media_type === 'video') {
    return <Box component="video" src={url} controls sx={sx} {...videoProps} />;
  }
  return <Box component="img" src={url} alt={media.caption || media.original_filename} sx={sx} />;
};

export default DecisionMedia;
